'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { Fragment } from 'react';
import { Link } from '../../../../actions/Link';
import { H4 } from '../../../typography/Heading';
import { P3 } from '../../../typography/Paragraph';
import { CoursesOptions } from '../_components/CourseOptions';
export function CoursesSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Popover className="relative">{_temp2}</Popover>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(t0) {
  const {
    open
  } = t0;
  return <><PopoverButton className="inline-flex items-center gap-x-1 font-medium text-slate-900 text-sm hover:text-algosecondary hover:underline focus:outline-none"><span>Kursy</span><ChevronDownIcon className={`h-3 w-3 transition-transform duration-200 ${open ? "rotate-180 transform" : ""}`} aria-hidden="true" /></PopoverButton><Transition as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-1"><PopoverPanel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4">{_temp}</PopoverPanel></Transition></>;
}
function _temp(t0) {
  const {
    close
  } = t0;
  return <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-slate-900/5 lg:max-w-3xl"><CoursesOptions onClose={close} /><div className="bg-slate-50 px-8 py-6"><div className="flex items-center gap-x-3"><H4>Interesuje Cię lista wszystkich kursów?</H4><Link href="/kursy" onClick={() => close()} className="flex items-center justify-center rounded-full bg-blue-100 px-2.5 py-1"><span className="font-semibold text-algosecondary text-xs hover:text-blue-500">Link</span></Link></div><P3 className="mt-2">Kliknij na link, aby zobaczyć listę wszystkich kursów!</P3></div></div>;
}